import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch , handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    selectRiskPdf: "selectRiskPdf [Action]",
    selectRiskPdfLoading: "selectRiskPdfLoading [Action]",
    selectRiskPdfAsync: "selectRiskPdfAsync [Action]",
};

const inistiaState = {
    data: {},
    total:0,
    loading: false
};

export const reducerselectRiskPdf = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectRiskPdf:
            return {
                ...state,
                data: payload.image_file,
                total: payload.image_file ? Object?.keys(payload.image_file)?.length :0
            };
        case actionTypes.selectRiskPdfLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectRiskPdfLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "brokercustomer",
        method_type: "select_risk_pdf",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.selectRiskPdf, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectRiskPdfLoading, payload: false })

    }
}

export function* workerselectRiskPdf() {
    yield takeLatest(actionTypes.selectRiskPdfAsync, handleWorker);
}
